import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { UtilsService } from "../../../../auth/service/utils.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AuthenticationService } from "../../../../auth/service";
import { ActivatedRoute } from "@angular/router";
import { TicketService } from "../../ticket.service";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import moment from "moment";
import { IMeTicket, ITicketSingle } from "../../models/tickets";

@Component({
  selector: "app-my-tickets-list",
  templateUrl: "./my-ticket-list.component.html",
  styleUrls: ["./my-ticket-list.component.scss"],
})
export class MyTicketListComponent implements OnInit {
  @ViewChild("viewTicket") viewTicket: ElementRef;
  public contentHeader: IContentHeader;
  public searchKeyword: string = "";
  public tableLimit: number = 10;
  public currentTicket: IMeTicket;
  public searchStatus: number = 10;
  public idFromNotifications: string = "";
  public popupeditTicketIsOpen: boolean = false;
  constructor(
    public _utilService: UtilsService,
    public _modalService: NgbModal,
    public _authenticationService: AuthenticationService,
    public _ticketService: TicketService,
    public activatedRoute: ActivatedRoute,
  ) {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.idFromNotifications = params.id;
    });
  }

  async ngOnInit() {
    this.contentHeader = {
      headerTitle: "MENU.MY_SUPPORT_REQUEST",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "TITLES.SUPPORT",
            isLink: false,
          },
          {
            name: "MENU.MY_SUPPORT_REQUEST",
            isLink: false,
          },
        ],
      },
    };
    await this.loadTicket();
  }

  updateTableLimit(event: { target: { value: string } }) {
    this.tableLimit = Number(event.target.value);
  }

  async loadTicket() {
    await this._ticketService.getMineTicket();
    this._ticketService.mineTicket = this._ticketService.mineTicket.sort((a, b) => (moment(b.insert_date) > moment(a.insert_date) ? 1 : -1));
    if (this.idFromNotifications) {
      this.modalOpen(this.viewTicket, Number(this.idFromNotifications));
    }
    this.ticketList();
  }

  ticketList() {
    let items: IMeTicket[] = this._ticketService.mineTicket;

    const keywords: string = this.searchKeyword.trim().toLowerCase();

    if (keywords.length > 0) {
      items = items.filter((item: IMeTicket) => item.title.toLowerCase().includes(keywords));
    }

    if (this.searchStatus < 3) {
      items = items.filter((item: IMeTicket) => Number(item.steps[0].status) === Number(this.searchStatus));
    }

    return items;
  }

  closeModal() {
    this.popupeditTicketIsOpen = false;
    this.currentTicket = null;
  }

  public async modalOpen(modalBasic, ticket: number) {
    this._utilService.showLoading();
    this._modalService.open(modalBasic, {
      size: "md",
      centered: true,
    });
    this.currentTicket = this._ticketService.mineTicket.find((item: IMeTicket) => item.id === Number(this.idFromNotifications));
    await this._ticketService
      .get(ticket)
      .then((response) => {
        this._utilService.hideLoading();
        response.last_step.status = Number(response.last_step.status);
        this.currentTicket = response;
      })
      .catch(() => {
        this._utilService.hideLoading();
      });
  }

  loadAttachment(file: string) {
    return this._utilService.getFile(file);
  }

  goToEdit(row: ITicketSingle) {
    this.popupeditTicketIsOpen = true;
    this.currentTicket = row;
  }

  async deleteTicket(ticket: IMeTicket) {
    let deleteText: string = await this._utilService.translate("ALERT.CONFIRM_DELETE_TEXT");
    deleteText += await this._utilService.translate("ALERT.CONFIRM_DELETE_THIS_OBJECT");
    deleteText += ` ${ticket?.title}`;

    await this._utilService
      .showSWALDeleteConfirmation({ text: deleteText })
      .then(async (result) => {
        if (result.value) {
          this._utilService.showLoading();
          await this._ticketService
            .deleteTicket(ticket.id)
            .then(async () => {
              await this.loadTicket();
              this._utilService.hideLoading();
              await this._utilService.showSWALSuccess({ text: "SUCCESS_DELETE_SUPPORT_REQUEST" });
            })
            .catch(async () => {
              this._utilService.hideLoading();
              await this._utilService.showSWALError({ text: "ERROR_DELETE_SUPPORT_REQUEST" });
            });
        } else if (result.isDismissed) {
          this._utilService.hideLoading();
          await this._utilService.showSWALError({
            title: "ABORTED_TITLE",
            text: "ABORTED_TEXT",
          });
        }
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_DELETE_COMMISSION" });
      });
  }

  protected readonly UtilsService = UtilsService;
}
